import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import "./_style.scss";
function Well({ children, look, classes = "", ...other }) {
    return (_jsx("div", { ...other, className: classNames({
            well: true,
            [`--${look}`]: look,
            classes,
        }), children: children }));
}
export default Well;
